import type { SceneObject } from "@src/features/assistantChat/afterimage/engine";
import { makeBot } from "@src/features/assistantChat/afterimage/orb";
import {
  BOT_SHAPE_SPECS,
  BOT_SHAPES,
  type BotShape,
  isBotShape,
  parseOutline,
} from "./botShapes";

const objects = new Map<BotShape, SceneObject>();

/** The orb for a bot shape, built once (its mesh is uploaded on first draw). */
export const botObject = (shape: BotShape): SceneObject => {
  let object = objects.get(shape);
  if (!object) {
    const spec = BOT_SHAPE_SPECS[shape];
    object = makeBot(parseOutline(spec.outline), spec.face, shape);
    objects.set(shape, object);
  }
  return object;
};

/** Stable per id: the same id always hashes to the same number. */
export const hashId = (id: string): number => {
  let hash = 0;
  for (let i = 0; i < id.length; i++) hash = (hash * 31 + id.charCodeAt(i)) | 0;
  return Math.abs(hash);
};

/** A stable default shape for an id (an agent's, or a gallery template's). */
export const defaultBotShape = (id: string): BotShape =>
  BOT_SHAPES[hashId(id) % BOT_SHAPES.length];

/** The agent's stored shape when it is one we draw, else its default. */
export const agentBotShape = (agent: {
  id: string;
  avatarBotShape?: string | null;
}): BotShape =>
  isBotShape(agent.avatarBotShape)
    ? agent.avatarBotShape
    : defaultBotShape(agent.id);
